/**
 * リンク接続を表すデータクラス
 */
import type { LinkId } from './types';
import type { NodeId, StickyZoneId } from 'balus-common';

export class Link {
  constructor(
    public readonly id: LinkId,
    public readonly src: NodeId | StickyZoneId,
    public readonly dest: NodeId | StickyZoneId
  ) {}
}
